module.exports = __webpack_public_path__ + "static/media/studio 7 rites of passge compendium tattoo gold.864x1184.46d82073.webp";